import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { User } from "../api";
import { setCookie, getCookie } from "../container/LoginHelper";
import { useGlobal } from "../global/user";
import { useBranding } from "../context/ThemeContext";
import Dashboard from "../api/dashboard";
import CustomHeader from "../container/Header";

const { Content } = Layout;

export default function Login() {
  const history = useHistory();
  const { slug } = useParams(); // 各公司專屬登入網址 #/{slug}
  const [account, setaccount] = useState("");
  const [password, setpassowrd] = useState("");
  const [error, setError] = useState(false);
  const [msg, setMsg] = useState("Error");
  const { setUser, setFields, setHasDashboard } = useGlobal();
  const { title, loginImage, applyLoginBranding } = useBranding();

  // 依網址代碼套用該公司的品牌（找不到就顯示系統預設）
  useEffect(() => {
    applyLoginBranding(slug);
  }, [slug, applyLoginBranding]);

  useEffect(() => {
    (async () => {
      const accessToken = getCookie();
      if (accessToken !== null) {
        let res = await User.CheckToken(accessToken);
        if (res.data.valid) {
          // 這裡不呼叫 setUser / setFields，維持原本行為：
          // 由目標頁面的 PageDirector 一次載入 user、fields 與選取的 field
          await redirectAfterLogin(res.data.userInfo);
        }
      }
    })();
  }, [history, setFields]);

  const redirectAfterLogin = async (userInfo) => {
    if (userInfo.class == process.env.REACT_APP_MANAGER_CALSS_LV) {
      setHasDashboard(false);
      history.push("/control");
      return;
    }
    if (userInfo?.company_id) {
      try {
        const result = await Dashboard.CheckExists(userInfo.company_id);
        if (result.exists) {
          setHasDashboard(true);
          history.push(`/dashboard/view/${userInfo.company_id}`);
          return;
        }
      } catch (e) {
        console.warn("CheckExists failed, fallback to control", e);
      }
    }
    setHasDashboard(false);
    history.push("/control");
  };

  const OnlogIn = async () => {
    if (account.length === 0) {
      setError(true);
      setMsg("帳號不可為空字串");
      return;
    } else if (password.length === 0) {
      setError(true);
      setMsg("密碼不可為空字串");
      return;
    }
    let response = await User.TryLogin(account, password);
    if (response.code === 200 && response.data.valid) {
      setError(false);
      setCookie(`accessToken_IoT3`, response.data.token, 1);
      let res = await User.CheckToken(response.data.token);
      setFields(res.data.fields);
      setUser(res.data.userInfo); // 品牌由 userInfo.branding 接手
      await redirectAfterLogin(res.data.userInfo);
    } else {
      setError(true);
      setMsg(response.data.message);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    OnlogIn();
  };

  return (
    <Layout>
      <CustomHeader />
      <Content style={{ padding: "24px", minHeight: "calc(100vh - 64px)" }}>
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6 col-xl-4 text-center">
            <div className="card-container" style={{ marginTop: "40px" }}>
              <img
                alt=""
                className="img-fluid mb-4"
                style={{ maxWidth: "min(300px, 80%)" }}
                src={loginImage}
              />
              <h5 className="mb-4" style={{ color: "var(--primary-text)" }}>
                {title}
              </h5>

              <form className="mx-auto" onSubmit={handleSubmit}>
                <div className="form-group">
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text" style={{ minWidth: "80px" }}>
                        <i className="fas fa-user"></i>
                        帳號
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      id="account"
                      placeholder="輸入帳號"
                      onChange={(e) => setaccount(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text" style={{ minWidth: "80px" }}>
                        <i className="fas fa-lock"></i>
                        密碼
                      </span>
                    </div>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      placeholder="輸入密碼"
                      onChange={(e) => setpassowrd(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    <strong>{msg}</strong>
                  </div>
                )}

                <button type="submit" className="btn btn-primary btn-block w-100">
                  送出
                </button>
              </form>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
}